import { createRoot } from "react-dom/client";
import "./Reset.css";

import App from "./Routes/App";

createRoot(document.getElementById("root")).render(<App />);
